import topicPage from './topicPage'
const pages = [topicPage] // add pages to this array
export default pages
